<div class="text-center py-6">
  <mat-icon class="text-icon-header !w-auto !h-auto">
    power_off
  </mat-icon>
</div>
<div class="text-center text-gray-700 p-8">
  <h2>404 - Not Found</h2>
  <p>The page you requested could not be found.</p>
</div>
